import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FormControlValidatorService } from 'src/app/components/shared/sharedServices/form-control-validator.service';
import { MuToastService } from 'src/app/components/shared/sharedServices/mu-toast.service';
import { FlagNotChanged, Flags } from 'src/app/components/shared/types/flags.type';
import { ObservableManager } from 'src/app/components/shared/types/observableManager.type';
import { sharedConstants } from 'src/environments/constants';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth.service';
import { ItemNumberToFilter } from '../../models/interface/itemNumberToFilter.interface';
import { PersonBillingFlags } from './auth-person-billing.flags';
import { MuUserService } from 'src/app/components/shared/sharedProtos/user/mu-user.service';
import { LayoutAuthService } from 'src/app/components/layout/pages/layout-auth/layout-auth.service';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { AuthPersonBillingActions } from './auth-person-billing.actions';
import { authConstants } from '../../auth.constants';
import { AccountType } from 'src/app/components/shared/models/interface/accountType.enum';
import { MuDeliveryService } from 'src/app/components/shared/sharedProtos/delivery/mu-delivery.service';
import { SharedAuthValidator } from 'src/app/components/shared/sharedConstants/auth.validators';
import { LoginSharedComponent } from 'src/app/components/shared/sharedModules/auth/login-shared/login-shared.component';
import { MuLayoutService } from 'src/app/components/shared/sharedProtos/layout/mu-layout.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PermissionMenuService } from 'src/app/components/shared/sharedModules/permission/permission-menu.service';
import { PermissionService } from 'src/app/components/shared/sharedModules/permission/permission.service';
import { MuCookieService } from 'src/app/components/shared/sharedServices/mu-cookie.service';
import { MuCryptService } from 'src/app/components/shared/sharedServices/mu-crypt.service';
import { StorageService } from 'src/app/components/shared/sharedServices/storage.service';
import { UserDataService } from 'src/app/components/shared/sharedServices/user-data.service';
import { UtilsService } from 'src/app/components/shared/sharedServices/utils.service';

@Component({
  selector: 'app-auth-person-billing',
  templateUrl: './auth-person-billing.component.html',
  styleUrls: ['./auth-person-billing.component.sass'],
})
export class AuthPersonBillingComponent implements OnInit, OnDestroy {
  private observableManager = new ObservableManager();
  flagList = new Flags<PersonBillingFlags>();
  tmpUser: { [key: string]: any } = {};
  userCreated: boolean;
  personBillingFlags = PersonBillingFlags;
  formData: UntypedFormGroup;
  documentTypeList: ItemNumberToFilter[];
  cityList: ItemNumberToFilter[];
  toastLife: number;
  country: number;
  actionList: Actions<AuthPersonBillingActions, any> = new Actions<AuthPersonBillingActions, any>();
  actionListEnum = AuthPersonBillingActions;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private muToastService: MuToastService,
    private layoutAuthtService: LayoutAuthService<PersonBillingFlags>,
    private validator: FormControlValidatorService,
    private muUserService: MuUserService,
    private authService: AuthService,
    private muDeliveryService: MuDeliveryService,
    private layoutService: MuLayoutService,
    private muCookieService: MuCookieService,
    private translateService: TranslateService,
    private utilsService: UtilsService,
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private muCryptService: MuCryptService<any>,
    private per: PermissionMenuService,
    private storageService: StorageService,
    private userDataService: UserDataService
  ) {
    this.tmpUser = JSON.parse((localStorage.getItem('mu-auth-person') || '{}') + '');
    this.country = parseInt(JSON.parse(localStorage.getItem('mu-auth-phone')).country + '', 10);
  }

  async ngOnInit(): Promise<void> {
    await this.initData();
    this.watchFlags();
  }

  ngOnDestroy(): void {
    this.observableManager.release();
    if (this.userCreated) {
      localStorage.removeItem('mu-auth-data');
      localStorage.removeItem('mu-auth-person');
      localStorage.removeItem('mu-auth-company');
      localStorage.removeItem('mu-auth-phone');
      return environment.guardClause;
    }
    const user: { [key: string]: any } = {};
    Object.keys(this.formData.controls).forEach(key => {
      user[key] = this.formData.get(key).value;
    });
    localStorage.setItem('mu-auth-person', JSON.stringify(user));
  }

  /**
   * init data
   */
  async initData(): Promise<void> {
    this.actionList.on(AuthPersonBillingActions.REGISTER, (_, __) => {
      this.register();
    });
    this.layoutAuthtService.updateSettings({
      tab: 1,
      step: 2,
      title: 'titleBilling',
      flagList: this.flagList,
      showFlag: PersonBillingFlags.SHOW_SUCCESS_MODAL,
      actionFlag: PersonBillingFlags.ACTION_SUCCESS_MODAL,
      loaderFlag: PersonBillingFlags.LOADING_SUCCESS_MODAL,
    });
    this.toastLife = environment.toastData.life;
    const sharedAuthValidator = new SharedAuthValidator(this.validator);
    this.formData = this.formBuilder.group({
      isInvalidForm: true,
      fullName: sharedAuthValidator.getPersonNames(),
      city: sharedAuthValidator.getCityId(),
      zipCode: sharedAuthValidator.getPostalCode(this.showZipCode),
      documentType: sharedAuthValidator.getDocumentType(),
      documentNumber: sharedAuthValidator.getDocumentNumber(this.showZipCode),
    });

    await this.getCityList();
    await this.getDocumentTypeList();

    if (!this.tmpUser) {
      return environment.guardClause;
    }

    Object.keys(this.tmpUser).forEach(key => {
      this.formData.get(key).setValue(this.tmpUser[key]);
    });
  }

  /**
   * show zip code by cuontry
   * @returns
   */
  get showZipCode(): boolean {
    return [3].includes(this.country);
  }

  /**
   * get city list
   */
  async getCityList(): Promise<void> {
    try {
      this.cityList = (await this.muDeliveryService.getCityList(sharedConstants.statusToFilterCity, this.country)).cityFormatedList;
    } catch (e) {}
  }

  /**
   * load document type list
   */
  async getDocumentTypeList(): Promise<void> {
    try {
      this.documentTypeList = await this.muUserService.getDocumentTypeList(this.country, AccountType.B2C);
    } catch (e) {}
  }

  /**
   * method to register user
   */
  async register(): Promise<void> {
    this.flagList.executeIfFalse(PersonBillingFlags.ACTION, async (test: FlagNotChanged) => {
      try {
        const user = JSON.parse(localStorage.getItem('mu-auth-data'));
        this.userCreated = await this.authService.registerPerson({
          cellPhone: parseInt(JSON.parse(localStorage.getItem('mu-auth-phone'))?.clientPhone + '', 10),
          email: user?.email,
          password: user?.password,
          name: this.formData.get('fullName').value,
          cityId: this.formData.get('city').value,
          documentType: this.formData.get('documentType').value,
          document: this.formData.get('documentNumber').value,
          roleId: authConstants.defaultPersonRole,
        });
        this.flagList.enable(PersonBillingFlags.SHOW_SUCCESS_MODAL);
      } catch (e) {
        this.muToastService.showSpecificToast({
          exception: e,
          key: 'toast-layout',
          severity: 'error',
          summary: 'toast.auth.error.register.title',
          detail: e.code === 1 && e.message ? e.message : 'toast.auth.error.register.text',
          life: this.toastLife,
        });
        this.formData.get('documentNumber').updateValueAndValidity();
        this.formData.get('documentNumber').setErrors({ unavailable: true });
      }
    });
  }

  /**
   * watch flag list
   */
  watchFlags(): void {
    this.observableManager.watch(this.flagList.valueChanges(PersonBillingFlags.ACTION_SUCCESS_MODAL)).subscribe(async flag => {
      if (!flag || this.flagList.get(PersonBillingFlags.LOADING_SUCCESS_MODAL)) {
        return environment.guardClause;
      }
      flag.toggle();
      const user = JSON.parse(localStorage.getItem('mu-auth-data'));
      const loginComponent = new LoginSharedComponent(
        this.layoutService,
        this.muCookieService,
        this.translateService,
        this.muUserService,
        this.formBuilder,
        this.utilsService,
        this.permissionService,
        this.validator,
        this.router,
        this.route,
        this.muCryptService,
        this.per,
        this.storageService,
        this.muDeliveryService,
        this.userDataService
      );
      this.flagList.enable(PersonBillingFlags.LOADING_SUCCESS_MODAL);
      this.userCreated = true;
      await loginComponent.signIn({ email: user.email, password: user.password }, true, true);
      localStorage.removeItem('mu-auth-data');
    });
  }
}
